import clsx from 'clsx';

import Text from '@modules/common/components/text';

interface BrandTitleProps {
  title: string;
  className?: string;
}

const BrandTitle = ({ title, className }: BrandTitleProps) => {
  return (
    <Text
      variant="h2-bold"
      as="h2"
      className={clsx(
        'border-primary-30 w-fit border-b-4 p-1',
        className
      )}
    >
      {title}
    </Text>
  );
};

export default BrandTitle;
